import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDivider = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: '2rem 0',
}));

export const StyledDividerLine = styled('span')(() => ({
  borderTop: `1px solid #dadce0`,
  width: `43%`,
}));

export const StyledDividerText = styled('span')(() => ({
  fontSize: '1.3rem',
  textTransform: 'uppercase',
}));

export const StyledSocialMediaButtonContainer = styled('div')(() => ({
  margin: '1rem 0',
}));

export const StyledSignInWithGoogleContainer = styled('div')(() => ({
  width: '100%',
  '& > div': {
    width: '100%',
  },
}));

export const StyledVerifyContainer = styled(Grid)(({ theme }) => ({
  margin: 'auto',
  height: '100%',
  [theme.breakpoints.up('sm')]: {
    width: '45rem',
  },
}));
